var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm-1.851 6.718H9.196v4.372h1.453v-4.372zm3.567-.103c-.723 0-1.072.373-1.272.666l-.038.056v-.62h-1.452c.005.114.007.497.008.993V12.95l-.008 2.087v.054h1.453v-2.442c0-.13.009-.261.048-.354.105-.261.344-.532.745-.532.526 0 .736.4.736.989v2.339h1.454v-2.507c0-1.343-.718-1.968-1.674-1.968zM9.933 8.61c-.498 0-.823.327-.823.755 0 .42.315.756.803.756h.01c.506 0 .821-.336.821-.756-.008-.428-.315-.755-.811-.755z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgLinkedin;